import { Link } from "react-router-dom";

const SECTIONS = [
  ["Cosa utilizziamo",
   "Questa applicazione utilizza esclusivamente cookie tecnici di sessione (autenticazione dell'area riservata) e l'archiviazione locale del browser (localStorage) per le preferenze dell'interfaccia. Sono strumenti necessari al funzionamento del servizio, esenti da consenso ai sensi della normativa vigente."],
  ["Cosa NON utilizziamo",
   "Nessun cookie di profilazione, nessun cookie di terze parti per finalità di marketing, nessuno strumento di tracciamento statistico o pubblicitario."],
  ["Come eliminarli",
   "Puoi eliminare cookie e dati locali in qualsiasi momento dalle impostazioni del tuo browser (sezione Privacy/Sicurezza). L'eliminazione del cookie di sessione comporta la disconnessione dall'area riservata."],
];

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 py-16 px-5" data-testid="cookie-page">
      <div className="max-w-2xl mx-auto">
        <Link to="/vetrina" className="text-xs text-zinc-500 hover:text-zinc-300 transition-colors">← dishenda.it</Link>
        <h1 className="font-display text-4xl font-extrabold tracking-tighter mt-4">Cookie Policy</h1>
        <p className="text-[11px] text-amber-400/90 bg-amber-400/10 border border-amber-400/20 rounded-md px-3 py-2 mt-4" data-testid="cookie-draft-note">
          Bozza standard — in fase di validazione legale. Ultimo aggiornamento: settembre 2026.
        </p>
        <div className="mt-8 space-y-7">
          {SECTIONS.map(([t, d]) => (
            <section key={t}>
              <h2 className="font-display font-bold text-lg text-zinc-100">{t}</h2>
              <p className="text-sm text-zinc-400 leading-relaxed mt-2">{d}</p>
            </section>
          ))}
        </div>
        <p className="text-xs text-zinc-600 mt-10">
          Vedi anche la <Link to="/privacy" className="underline hover:text-zinc-400">Privacy Policy</Link>.
        </p>
      </div>
    </div>
  );
}
